<template>
	<div>
		<breadcrumb :main-name="isEdit? '编辑计划' : '新建计划' " :breadcrumbList="breadcrumbList"></breadcrumb>

		<div class="m-setting">
			<div class="m-plan-box">
				<a-steps :current="current" class="m-steps">
				    <a-step title="投放计划设置"/>
				    <a-step title="受众设置"/>
				    <a-step title="制作创意"/>
				</a-steps>
				<router-view></router-view>
			</div>
		</div>
	    <a-drawer
	    	
	      	title="投放计划概要"
	      	placement="right"
	      	:closable="false"
	      	@close="onClose"
	      	:visible="visible"
	      	width:300
	    >
			<ul class="m-drawer">
				<li>
                    <span>公司名称：</span>
                    <span>{{showformItem.companyName}}</span>
				</li>
				<li>
                    <span>公司品牌：</span>
                    <span>{{showformItem.companyBrand}}</span>
				</li>
				<li>
                    <span>计划名称：</span>
                    <span>{{showformItem.planName}}</span>
				</li>
				<li>
                    <span>广告类型：</span>
                    <span>{{showformItem.adSystemName}}</span>
				</li>
				<li>
                    <span>计费方式：</span>
                    <span v-if="showformItem.priceStrategy==1">轮播广告</span>
                    <span v-if="showformItem.priceStrategy==2">精准广告</span>
                    <span v-if="showformItem.priceStrategy==3">曝光广告</span>
				</li>
				<li>
                    <span>开始时间：</span>
                    <span>{{showformItem.beginTime}}</span>
				</li>
				<li>
                    <span>结束时间：</span>
                    <span>{{showformItem.endTime}}</span>
				</li>
				<li v-if="showformItem.priceStrategy===2">
					<span>受众类型：</span>
					<span>{{showformItem.condition}}</span>
				</li>
				<li>
                    <span>添加区域：</span>
                    <span>{{showformItem.target}}</span>
				</li>
			</ul>
            <div 
            	@click="onClose"
				v-if="visible"
                class="ad_icon-left" type="primary">
                <a-icon type="double-right" />
            </div>
	    </a-drawer>
		</div>
</template>
<script>
	import breadcrumb from '../common/Breadcrumb.vue'
	import {mapState} from 'vuex'
    export default {
        components: {
            breadcrumb
        },
        data() {
            return {
                // 面包屑
                breadcrumbList: [
                    {
                        name: '广告计划',
                        path: '/channelAdPlan'
                    }
                ],
                // 步骤数
                current: 0,
                visible: false,
                // 投放计划概要
                showformItem:{
                	companyId:"-",
		            companyName:"",
		            companyBrandId:"",
		            companyBrand:"",
		            planName:"",
		            priceStrategy:"1",
		            adSystem:"",
		            charge:"",
		            beginTime:"",
		            endTime:"",
					condition:'',
		            target:[]
                },
				// 新建还是编辑
				isEdit:false,
            }
        },
		watch:{
		  	$route(to,from){
	            /**
	             * 获取路由地址，设置steps
	             */
	            this.setSteps();
		  	}
		},
        methods: {
        	getUrl(){
        		var path = this.$route.path.split("/");
        		return path[path.length-1]
        		
        	},
        	setSteps(){
        		var path = this.getUrl();
        		switch(path){
        			case 'channelPlanSet':
        				this.current = 0
        			break;
        			case 'channelTargetSet':
        				this.current = 1
        			break;
        			case 'channelMaterialSet':
        				this.current = 2
        			break;
        		}
        	},
		    showDrawer() {
		       this.visible = true;
		       //this.showformItem = this.$store.state.formItem
		       this.showformItem = JSON.parse(window.sessionStorage.formItem);
		    },
		    onClose() {
		       this.visible = false;
		    },
		    getmapState(){
		    	//this.showformItem = this.$store.state.formItem
		    	this.showformItem = JSON.parse(window.sessionStorage.formItem);
		    }
        },
        mounted(){
        	// 获取vuex中planinfo
        	//this.getmapState()
			this.setSteps()
			if(window.sessionStorage.planId) {
				this.isEdit = true
			} else {
				this.isEdit = false
			}
        }
    }

</script>
<style lang="scss">
	.m-setting{
		width: 100%;
		padding: 24px;
		.m-plan-box{
			width: 100%;
			background: #fff;
			padding: 36px 32px;
			.m-steps{
			    width: 600px;
			    margin: 0 auto 36px;
			}
		}
	}
	.u-open-drawer{
		border: none;
	    position: fixed;
	    width: 40px;
	    height: 40px;
	    right: 48px;
	    top: 50%;
	    border-radius: 50%;
	    margin-top: -8px;
	    box-shadow: 0 4px 12px 0 rgba(0,0,0,.1);
	    text-align: center;
	    line-height: 35px;
	    z-index: 1000;
	    background: #fff;
	    i{
	    	margin-left: -2px;
	    }
	}
    .ad_icon-left {
        position: fixed;
        width: 40px;
        height: 40px;
        right: 48px;
        top: 50%;
        border-radius: 50%;
        margin-top: -8px;
        box-shadow: 0px 4px 12px 0px rgba(0, 0, 0, 0.1);
        text-align: center;
        line-height: 50px;
        z-index: 1000;
        background: #fff;
		border:0px;
		position:absolute;
		left:-20px;
		top:54.4%;
		z-index:2000;
		cursor: pointer;
		margin-top:-50px;    
		line-height: 43px;
	    .ad_icon-left-coin {
	        display: inline-block;
	        position: absolute;
	        left: 11px;
	        top: 15px;
	        width: 16px;
	        height: 17px;
	        background-size: 463px 290px !important;
	        // background: url("../../assets/images/cssSprite.png") no-repeat;
	        background-position: -139px -63px;
	    }
	    .ad_icon-left-coin_right {
	        display: inline-block;
	        position: absolute;
	        left: 11px;
	        top: 15px;
	        width: 16px;
	        height: 17px;
	        background-size: 463px 290px !important;
	        // background: url("../../assets/images/cssSprite.png") no-repeat;
	        background-position: -139px -91px;
	    }        
    }
	.m-drawer{
		li{
			margin:8px 0 8px 8px
		}
	}
</style>